module.exports = __webpack_public_path__ + "img/2.身份证反面.ded40551.png";